import React,{Component} from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class AusstellungenItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			animateClass : 'fadeOut'
		}	
		this.onChange = this.onChange.bind(this);
	}
	onChange(isVisible){
		if(isVisible) { 
			this.setState({ animateClass : 'fadeIn' });
		}
	}
	render(){
		const {title,slug,image_title,image_alt:alt,image:imgUrl,image_tiny} = this.props;
		let divStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}		
		return(
			<VisibilitySensor partialVisibility={true} offset={{top:300}} onChange={this.onChange} >
				<article className={`article-item col-md-4 ${this.state.animateClass}`}>
				   <UISref to="root.diskussionendetails" params={{item:slug}}>
					   <a>	
							<div className="fixed-ht-img ratio-news" >
                                <div title={image_title} className="img-wrapper" style={divStyle}>
                                </div>
							</div>
							<h2 className="h2" dangerouslySetInnerHTML={createMarkup(title)}></h2>
						</a>
					</UISref>
				</article>
			</VisibilitySensor>
		)
	}
}
export default AusstellungenItem;


// WEBPACK FOOTER //
// ./src/components/DiskussionenItem.js